import { useMutation } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import { downloadFile, generateTimestampedFilename } from '@/lib/fileDownload';
import type { MutationConfig } from '@/lib/react-query';

interface ExportSandboxParams {
  sandboxId: string;
}

/**
 * Export a sandbox configuration as a JSON file
 * Downloads the file directly to the user's browser
 */
export const exportSandbox = async ({ sandboxId }: ExportSandboxParams): Promise<void> => {
  const response = await api.get<Blob>(`/v1/sandboxes/${sandboxId}/export`, {
    responseType: 'blob',
  });

  // Use generic file download utility
  const defaultFilename = generateTimestampedFilename(`sandbox_export_${sandboxId}`, 'json');
  downloadFile(response, defaultFilename, 'application/json');
};

interface UseExportSandboxOptions {
  mutationConfig?: MutationConfig<typeof exportSandbox>;
}

export const useExportSandbox = ({
  mutationConfig,
}: UseExportSandboxOptions = {}) => {
  return useMutation({
    mutationFn: exportSandbox,
    ...mutationConfig,
  });
};
